export default {
    MONTHLY: {
        PRICE_5_ID: 'monthly',
        PRICE_5_VALUE: 5,
        PRICE_7_ID: 'monthly_7',
        PRICE_7_VALUE: 7,
        PRICE_9_ID: 'monthly_9',
        PRICE_9_VALUE: 9.95,
        PRICE_BUSINESS_ID: 'monthly_business',
        PRICE_BUSINESS_VALUE: 5
    },
    ANNUAL: {
        PRICE_48_ID: 'annual',
        PRICE_48_VALUE: 48,
        PRICE_60_ID: 'annual_60',
        PRICE_60_VALUE: 60,
        PRICE_95_ID: 'annual_95',
        PRICE_95_VALUE: 95.40,
        PRICE_BUSINESS_ID: 'annual_business',
        PRICE_BUSINESS_VALUE: 48
    },
    planValue(plan) {
        if (plan === this.MONTHLY.PRICE_5_ID) {
            return this.MONTHLY.PRICE_5_VALUE;
        }
        if (plan === this.MONTHLY.PRICE_7_ID) {
            return this.MONTHLY.PRICE_7_VALUE;
        }
        if (plan === this.MONTHLY.PRICE_9_ID) {
            return this.MONTHLY.PRICE_9_VALUE;
        }
        if (plan === this.MONTHLY.PRICE_BUSINESS_ID) {
            return this.MONTHLY.PRICE_BUSINESS_VALUE;
        }
        if (plan === this.ANNUAL.PRICE_48_ID) {
            return this.ANNUAL.PRICE_48_VALUE;
        }
        if (plan === this.ANNUAL.PRICE_60_ID) {
            return this.ANNUAL.PRICE_60_VALUE;
        }
        if (plan === this.ANNUAL.PRICE_95_ID) {
            return this.ANNUAL.PRICE_95_VALUE;
        }
        if (plan === this.ANNUAL.PRICE_BUSINESS_ID) {
            return this.ANNUAL.PRICE_BUSINESS_VALUE;
        }
        return this.MONTHLY.PRICE_7_VALUE;
    },
    isMonthly(plan) {
        return plan === this.MONTHLY.PRICE_5_ID
            || plan === this.MONTHLY.PRICE_7_ID
            || plan === this.MONTHLY.PRICE_9_ID
            || plan === this.MONTHLY.PRICE_BUSINESS_ID;
    },
    isAnnual(plan) {
        return plan === this.ANNUAL.PRICE_48_ID
            || plan === this.ANNUAL.PRICE_60_ID
            || plan === this.ANNUAL.PRICE_95_ID
            ||plan === this.ANNUAL.PRICE_BUSINESS_ID;
    }
}